module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Divider is a graphic element placed as in the page as a visual divider, meant for layouting purposes.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Divider /&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Divider/README.md
// module id = 345
// module chunks = 0